import React from 'react'
import { IPublishedGraphic } from '../../types/publishedGraphic'
import {
  getPublishedSource,
  isInteractive,
} from '../../services/publishedGraphic'
import { TrPlaceholder, Image } from '../../components'
import { InteractiveGraphicWrapper } from './styled'

interface IPublishedGraphicPreview {
  publishedGraphic: IPublishedGraphic
}

export const PublishedGraphicPreview = ({
  publishedGraphic,
}: IPublishedGraphicPreview) => {
  const publishedURL = getPublishedSource(publishedGraphic)
  return !publishedURL ? (
    <div>
      <TrPlaceholder bordered />
    </div>
  ) : isInteractive(publishedGraphic) ? (
    <InteractiveGraphicWrapper>
      <iframe src={publishedURL} title="Interactive Graphic" />
    </InteractiveGraphicWrapper>
  ) : (
    <div>
      <Image bordered={true} src={publishedURL} alt="Preview" />
    </div>
  )
}
